import React, { Component } from 'react';
import instance from "../axios-instance";
import MainSettingContext from './MainSettingContext';
import Systems from "../SystemFunction";
import { t } from './i18n';

class Toprank extends Component {
    static contextType = MainSettingContext;
    constructor(props) {
        super(props)
        this.state = {
            rankList: [],
            loading: true,
            loginstate: props.loginstate || false,
            username: props.username || "",
            userid: props.userid || null,
            tblprofile: props.tblprofile || null,
            balance: props.balance || 0,
            point: props.point || 0,
        }
    }

    async componentDidMount() {
        await this.loadTopRank();
    }

    loadTopRank = async () => {
        this.setState({ loading: true });
        try {
            const res = await instance.post("/api/v1/gettoprank", { System: Systems });
            if (res.data.status === 200) {
                this.setState({ rankList: res.data.message || [], loading: false });
            } else {
                this.setState({ rankList: [], loading: false });
            }
        } catch (err) {
            this.setState({ rankList: [], loading: false });
        }
    }

    maskUsername(name) {
        if (!name) return "***";
        if (name.length <= 4) return name[0] + "***";
        return name.substring(0, 3) + "***" + name.slice(-2);
    }

    getRankIcon(idx) {
        if (idx === 0) return "🥇";
        if (idx === 1) return "🥈";
        if (idx === 2) return "🥉";
        return `#${idx + 1}`;
    }

    render() {
        const lang = this.props.language || this.context?.language || 'th';
        const { rankList, loading } = this.state;
        return (
            <>
                <div className="container p-0 x-margin-top-v3">
                    <div className="row m-0 border-shadow-title">
                        <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                            <div className="text-center bg-title-web" style={{ paddingTop: 50 }}>
                                <div>
                                    <div className="text-title text-white-v1 text-center">
                                        <div className="d-flex justify-content-between">
                                            <div className="text-white-v1-deposit">
                                                <a role="button" href="/event">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="currentColor" className="bi bi-arrow-left-circle text-white" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                                                    </svg>
                                                </a>
                                            </div>
                                            <div className="text-white-v1-deposit">
                                                <h5>{t(lang, 'toprank_title')}</h5>
                                            </div>
                                            <div>
                                                <button onClick={this.loadTopRank} style={{ background: "none", border: "none", cursor: "pointer" }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="currentColor" className="bi bi-arrow-clockwise text-white-v1" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <hr className="mt-0" />
                                    </div>
                                </div>
                            </div>

                            <div className="p-2 bg-profile-box-overview animated animatedFadeInUp fadeInUp">
                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-light" role="status" />
                                        <p className="mt-2 text-white-v1">{t(lang, 'loading')}</p>
                                    </div>
                                ) : rankList.length === 0 ? (
                                    <div className="text-center py-5">
                                        <div style={{ fontSize: 48 }}>🏆</div>
                                        <p className="text-white-v1 mt-2">{t(lang, 'no_data')}</p>
                                    </div>
                                ) : (
                                    <div className="mt-2">
                                        <div className="text-center mb-3">
                                            <span className="text-white-v1" style={{ fontSize: 13, opacity: 0.75 }}>{t(lang, 'toprank_subtitle')}</span>
                                        </div>
                                        <table className="table table-borderless mb-0" style={{ color: "#fff" }}>
                                            <thead>
                                                <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.15)", fontSize: 13 }}>
                                                    <th style={{ width: 50, textAlign: "center", paddingBottom: 8 }}>{t(lang, 'rank_col')}</th>
                                                    <th style={{ paddingBottom: 8 }}>{t(lang, 'username_col')}</th>
                                                    <th style={{ textAlign: "right", paddingBottom: 8 }}>{t(lang, 'credit_col')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rankList.map((item, idx) => (
                                                    <tr key={idx} style={{
                                                        background: idx < 3 ? "rgba(255,215,0,0.07)" : "transparent",
                                                        borderBottom: "1px solid rgba(255,255,255,0.07)",
                                                        transition: "background 0.2s"
                                                    }}>
                                                        <td style={{ textAlign: "center", verticalAlign: "middle", fontSize: idx < 3 ? 22 : 14, fontWeight: 700 }}>
                                                            {this.getRankIcon(idx)}
                                                        </td>
                                                        <td style={{ verticalAlign: "middle" }}>
                                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                                <div style={{
                                                                    width: 32, height: 32, borderRadius: "50%",
                                                                    background: "linear-gradient(135deg,#f6dd8b,#d6a739)",
                                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                                    fontWeight: 700, fontSize: 14, color: "#2b1c00", flexShrink: 0
                                                                }}>
                                                                    {(item.playerid || item.username || "?")[0]?.toUpperCase()}
                                                                </div>
                                                                <span style={{ fontSize: 14 }}>
                                                                    {this.maskUsername(item.playerid || item.username)}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td style={{ textAlign: "right", verticalAlign: "middle", fontWeight: 700, fontSize: 14, color: idx < 3 ? "#f6dd8b" : "#fff" }}>
                                                            {Number(item.Winner || item.winner || 0).toLocaleString()}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Toprank;
